"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

require('./chunk-NESC3UD7.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

var _jsxruntime = require('react/jsx-runtime');

var t = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "YoutubeIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M25.5403 9.50346C25.2873 8.51804 24.5418 7.74196 23.5953 7.47858C21.8796 7 15 7 15 7C15 7 8.12044 7 6.40474 7.47858C5.45821 7.742 4.71273 8.51804 4.45971 9.50346C4 11.2896 4 15.0162 4 15.0162C4 15.0162 4 18.7428 4.45971 20.5289C4.71273 21.5143 5.45821 22.258 6.40474 22.5214C8.12044 23 15 23 15 23C15 23 21.8796 23 23.5953 22.5214C24.5418 22.258 25.2873 21.5143 25.5403 20.5289C26 18.7428 26 15.0162 26 15.0162C26 15.0162 26 11.2896 25.5403 9.50346ZM12.75 18.3996V11.6327L18.5 15.0163L12.75 18.3996Z"
  }),
  svgElements: ["path"]
});

exports.YoutubeIconMedium = t;